import { supabase, supabaseConfigError } from "./supabaseClient";

const LS_KEY = "yojitsu_v1";

export function loadLS(companyId = "fujimi") {
  try {
    const raw = localStorage.getItem(`${LS_KEY}_${companyId}`);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function saveLS(data, companyId = "fujimi") {
  try {
    localStorage.setItem(`${LS_KEY}_${companyId}`, JSON.stringify(data));
    return { ok: true, error: null };
  } catch (error) {
    console.error("[yojitsu] saveLS error:", error);
    return { ok: false, error };
  }
}

export async function loadDB(companyId = "fujimi") {
  if (!supabase) {
    return { ok: false, data: null, error: new Error(supabaseConfigError || "Supabase is not configured"), source: null };
  }

  try {
    const { data: { user }, error: userError } = await supabase.auth.getUser();
    if (userError) return { ok: false, data: null, error: userError, source: null };
    if (!user) return { ok: true, data: null, error: null, source: null };

    const { data, error } = await supabase
      .from("yojitsu_data")
      .select("data")
      .eq("user_id", user.id)
      .eq("company_id", companyId)
      .single();

    if (error) {
      if (error.code === "PGRST116") {
        return { ok: true, data: null, error: null, source: "db" };
      }
      console.error("[yojitsu] loadDB error:", error);
      return { ok: false, data: null, error, source: null };
    }

    return { ok: true, data: data?.data ?? null, error: null, source: "db" };
  } catch (error) {
    console.error("[yojitsu] loadDB unexpected error:", error);
    return { ok: false, data: null, error, source: null };
  }
}

export async function saveDB(data, savedBy, companyId = "fujimi") {
  if (!supabase) {
    return { ok: false, error: new Error(supabaseConfigError || "Supabase is not configured") };
  }

  try {
    const { data: { user }, error: userError } = await supabase.auth.getUser();
    if (userError) return { ok: false, error: userError };
    if (!user) return { ok: false, error: new Error("ログインユーザーが取得できません") };

    const { error } = await supabase
      .from("yojitsu_data")
      .upsert({
        user_id: user.id,
        company_id: companyId,
        data,
        saved_at: new Date().toISOString(),
        saved_by: savedBy ?? "",
      }, { onConflict: "user_id,company_id" });

    if (error) {
      console.error("[yojitsu] saveDB error:", error);
      return { ok: false, error };
    }

    return { ok: true, error: null };
  } catch (error) {
    console.error("[yojitsu] saveDB unexpected error:", error);
    return { ok: false, error };
  }
}
